if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

// ========================================
function validateQuantity($parentElement) {
  const $message = $parentElement.find('.product-form__error-message-wrapper');
  const $quantity = $parentElement.find(".quantity__input");
  const $select = $parentElement.find("select");
  const $selectedOption = $select.find("option:selected");
  let qty = 0;
  if ($selectedOption.length == 0) {
    qty = $quantity.data('qty');
  } else {
    qty = $selectedOption.data("qty");
  }
  
  const inputQty = parseInt($quantity.val(), 10) || 0;

  if (inputQty >= qty) {
    $quantity.val(qty);
    $parentElement.find('.quantity__button[name="plus"]').addClass('disable');
    $message.find(".product-form__error-message")
      .text(`You've reached the maximum available quantity of ${qty}.`)
      .closest(".product-form__error-message-wrapper")
      .removeAttr("hidden");
  } else {
    $parentElement.find('.quantity__button[name="plus"]').removeClass('disable');
    $message.attr("hidden", true);
  }
}
// --- Product form ---
$(document).on("click", ".quantity__button", async function (event) {
  event.preventDefault();
  const $button = $(this);
  const $parentElement = $button.closest(".product__info-wrapper");
  validateQuantity($parentElement);
});

$(document).on("input", ".quantity__input", function () {
  const $input = $(this);
  const $parentElement = $input.closest(".product__info-wrapper");
  validateQuantity($parentElement);
});

// --- Sticky ATC ---
$(document).on("input", '.sticky-atc__inner input[type="number"][name="quantity"]', function () {
  const $input = $(this);
  const $parent = $input.closest(".sticky-atc__inner");
  const $message = $parent.find(".sticky-error-message");

  const $select = $parent.find("select");
  const $selectedOption = $select.find("option:selected");
  let maxQty = 0;
  if ($selectedOption.length == 0) {
    maxQty = $input.data("qty");
  } else {
    maxQty = $selectedOption.data("qty") || 1;
  }

  let currentQty = parseInt($input.val(), 10) || 0;

  if (currentQty > maxQty) {
    $input.val(maxQty);
    $message
      .text(`You've reached the maximum available quantity of ${maxQty}.`)
      .removeAttr("hidden");
  } else {
    $message.attr("hidden", true);
  }

  const minQty = parseInt($input.attr("min"), 10) || 1;
  if (currentQty < minQty) {
    $input.val(minQty);
  }
});

$(document).on("change", ".sticky-atc__opt", function () {
  const $parent = $(this).closest(".sticky-atc__inner");
  const $message = $parent.find(".sticky-error-message");
  $message.text('');
  $parent.find('input[type="number"][name="quantity"]').val(1);
});